import {
  candidateInterviewConstants,
  publicProfileConstants,
} from "../../_constants";

const initialState = {};

// view assigned interview kit reducer
export const view_assigned_interview_kit_candidate_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateInterviewConstants.VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        interviewKitPreviewData: action.payload,
      };
    case candidateInterviewConstants.VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const get_interview_question_details_candidate_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_REQUEST:
    case candidateInterviewConstants.GET_ASSIGNED_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateInterviewConstants.GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_SUCCESS:
    case candidateInterviewConstants.GET_ASSIGNED_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        questionData: action.payload,
      };
    case candidateInterviewConstants.GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_FAILURE:
    case candidateInterviewConstants.GET_ASSIGNED_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const get_mux_interview_video_upload_url_candidate_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        uploadUrlData: action.payload,
      };
    case candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

// upload asset playback id reducer
export const get_mux_interview_video_upload_playback_id_candidate_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        assetPlaybackIdData: action.payload,
      };
    case candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const review_interview_kit_candidate_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_REQUEST:
    case publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        interviewKitReviewData: {},
      };
    case candidateInterviewConstants.REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_SUCCESS:
    case publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        interviewKitReviewData: action.payload,
      };
    case candidateInterviewConstants.REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_FAILURE:
    case publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const interview_submit_request_candidate_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_SUCCESS:
    case candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_SUCCESS:
    case candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        interviewSubmitRequestData: action.payload,
      };
    case candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const get_recently_assigned_assessment_kits_list_candidate_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateInterviewConstants.GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        assignedAssessmentKitsListData: action.payload,
      };
    case candidateInterviewConstants.GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const accept_assigned_assessment_kit_candidate_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        acceptAssignedAssessmentKitData: action.payload,
      };
    case candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const accept_assigned_assessment_kit_details_candidate_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        acceptAssignedAssessmentKitDetailsData: action.payload,
      };
    case candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};
// candidate reducer
export const get_jobs_linked_with_assigned_assessment_kit_candidate_action = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateInterviewConstants.GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateInterviewConstants.GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        jobsLinkedWithAssignedKitData: action.payload,
      };
    case candidateInterviewConstants.GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};
